import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from '../../../i18n';

import { actions as ratesActs, selectors as fromRates } from '../../../entities/rates';
import { SweetModal } from '../../ui/modal/sweet-modal';

export const ZipModal: React.FC = () => {
  const [t] = useTranslation('rates');

  const dispatch = useDispatch();

  const { postCode } = useSelector(fromRates.getReceiver);
  const opened = useSelector(fromRates.showZipModal);

  const zip = Number(postCode);
  const from = zip - 1;
  const to = zip + 1;

  const handleClose = useCallback(() => {
    dispatch(ratesActs.setZipModal({ zipCode: false }));
  }, []);

  if (opened) {
    return (
      <SweetModal open={opened} onClose={handleClose}>
        <div>{t('rates.zipModal.message', { from, to })}</div>
      </SweetModal>
    );
  }

  return null;
};
